import React from 'react';

import { SVGAsset } from '../svg-asset';
import {
    TeacherAdminIcons, getTeacherAdminIcon
} from './all-teacher-icons';

export type TeacherAdminIconProps =
    & Omit<any, 'src'>
    & {
    ['aria-label']?: string
    icon: TeacherAdminIcons
    width?: number
};

/**
 * Renders an Icon by name from the 3p-teacheradmin-assets module.
 */
export const TeacherAdminIcon = ({
    width = 20, icon, ...restProps
}: TeacherAdminIconProps) => {
    const src = getTeacherAdminIcon(icon);

    return (
        <SVGAsset
            {...restProps}
            width={width}
            src={src}
        />
    );
};
